var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVideo = function SvgVideo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 1.25,
    d: "M3.125 10h3.333m-3.333 0V6.563m0 3.437v3.438M6.458 10h7.084m-7.084 0v3.438m0-3.438V6.563M13.542 10h3.333m-3.333 0v3.819m0-3.819V6.563M16.875 10V6.563m0 3.437v3.819m-3.333 3.056h.833a2.5 2.5 0 0 0 2.5-2.5v-.556m-3.333 3.056v-3.056m0 3.056H6.458m7.084-13.75h.833a2.5 2.5 0 0 1 2.5 2.5v.938m-3.333-3.438v3.438m0-3.438H6.458m7.084 3.438h3.333m-3.333 7.256h3.333M6.458 16.875h-.833a2.5 2.5 0 0 1-2.5-2.5v-.937m3.333 3.437v-3.437m0-10.313h-.833a2.5 2.5 0 0 0-2.5 2.5v.938m3.333-3.438v3.438m-3.333 0h3.333m-3.333 6.875h3.333"
  })));
};
export default SvgVideo;